import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "../../../../../environments/environment";

@Injectable({
  providedIn: "root",
})
export class CitronellaExternalAPIService {
  configUrl: string;
  // dummy
  private url = "";
  private path = "";
  private token = "";
  // private url = environment.unileverDummyUrl;
  // private path = "api/mapix/VirtualLocation/Images";
  // private token = "Wm1SnbNL+F2hds5X8yPgfehQHo4s/hHQeHfyWjV5SlEkZMGTbGNpIMtcrjby8g8SwZNxiLDPG7dI7T2isyBay1IUZ9xFnbBvLO4361cRPU3YREZh/DSyGm7PGsgWVj0f1ttFeYeOwsBxltCpEOU3HjuECTLbGwrkbSjUVprZsFvl3ZbBjqxL+htNtIS9D5WABMoz/dMITVAaoAaSh53KPq5bE7S8JplZna1GXCOuCUALrpAv/3vaCeZFslrqZeGM";

  constructor(
    private http: HttpClient
  ) {
    this.configUrl = environment.host;
  }

  setUrlSettings(url: string, path: string, token: string) {
    this.url = url;
    this.path = path;
    this.token = token;
  }

  getUrlSettings(){
    return {
      url: this.url,
      path: this.path,
      token: this.token
    };
  }

  isUrlSettingComplete(): boolean {
    return this.url !== null && this.url !== "" && this.path !== null && this.path !== "" && this.token !== null && this.token !== "";
  }

  getVirtualLocationImages(VirtualCategoryId:number, VirtualIdentifier: string, MapixUserId: string): Observable<any> {
    console.log(`api/CitronellaActions/GetVirtualLocationImages/${VirtualCategoryId}/${VirtualIdentifier}/${MapixUserId}`);
    const Headers: any = {
      "Authorization": this.token,
      "Content-Type": "application/json"
    };
    return this.http.get<any>(this.url + this.path + `?VirtualCategoryId=${VirtualCategoryId}&VirtualIdentifier=${VirtualIdentifier}&MapixUserId=${MapixUserId}`, { headers: Headers });
  }

  getVirtualLocationImagesFetch(VirtualCategoryId:number, VirtualIdentifier: string, MapixUserId: string) : Promise<any> {
    return fetch(this.url + this.path + `?VirtualCategoryId=${VirtualCategoryId}&VirtualIdentifier=${VirtualIdentifier}&MapixUserId=${MapixUserId}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "Authorization": this.token
      }
    })
    .then(response => {
      return response.json() as Promise<any>;
    })
    .catch(error => {
      return Promise.reject(error);
    });

  }


}
